import type { FC } from 'react';
import type { ScatterPlotProps } from './types';
import ScatterPlotWidget from './scatter-plot-widget';
import './scatter-plot-styles.scss';
import { ScatterPlotProvider } from '../../../../providers/widgets/scatter-plot-provider/scatter-plot-provider';

const ScatterPlotWrapperProvider: FC<ScatterPlotProps> = (props) => (
  <ScatterPlotProvider providerKey={props.providerKey}>
    <ScatterPlotWidget {...props} />
  </ScatterPlotProvider>
);

export default ScatterPlotWrapperProvider;
